import { UploadedFileModel } from "../components/file-uploader/file-uploader.component";

export class DetailDTO {
  public image: string;
  public images: string[];
  public dateFrom: Date | null;
  public dateTo: Date | null;
  public startEvent: Date | null;
  public endEvent: Date | null;
  public categoryName: string | null;
  public name: string;
  public locationString: string | null;
  public description: string;
  public files: UploadedFileModel[];
  public locationLat?: number | null;
  public locationLng?: number | null;
  public id: number;
  public ticketId: number;
  public allDay: boolean;
  public summary: string;
  public isEvent = false;
}
